export const CollapseDownIcon = ({ color = "#A7A7A7", size = 10, ...props }) => (
    <svg
        width={size}
        height={size * (6 / 10)}
        viewBox="0 0 10 6"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M0.757812 0.727539L5.00045 4.97018L9.24309 0.727539"
            stroke={color}
        />
    </svg>
);
